import Axios from "axios";

const getEditableSiteVisitReport = async (id, token) =>
  await Axios.get(`${window.API}/site-visit/editable/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

export { getEditableSiteVisitReport };
